"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MypageCustomerServiceWidgetDataSchemaV2 = void 0;
var zod_1 = require("zod");
var MypageCustomerServiceItemImageSchema = zod_1.z.object({
    url: zod_1.z.string(),
    width: zod_1.z.number(),
    height: zod_1.z.number(),
    alt: zod_1.z.string(),
});
var MypageCustomerServiceItemSchema = zod_1.z.object({
    title: zod_1.z.string(),
    image: MypageCustomerServiceItemImageSchema,
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
exports.MypageCustomerServiceWidgetDataSchemaV2 = zod_1.z.object({
    header: zod_1.z.object({ title: zod_1.z.string() }).nullable(),
    items: zod_1.z.array(MypageCustomerServiceItemSchema),
});
